"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var replaceFill_1 = __importDefault(require("./replaceFill"));

var CMSIconContext_1 = require("./CMSIconContext");

function useCMSIcon(name, color, noEmitError) {
  var iconsQuery = (0, react_1.useContext)(CMSIconContext_1.IconsContext);
  if (!iconsQuery) return undefined;
  var icons = iconsQuery.iconsQuery.nodes;

  if (icons.length === 0) {
    if (noEmitError) return undefined;
    throw new Error("No icons found in icons context. Does a parent " + "component include the <CMSIconsProvider /> " + "component and is that component passed a non-empty " + "result from useCMSIconsQuery() query hook? ");
  }

  var icon = icons.find(function (icon) {
    return icon.data.Name === name;
  });

  if (!icon) {
    if (noEmitError === true) return undefined;
    throw new Error("Icon ".concat(name, " not found in ") + "Airtable. Does the airtable base include the " + "Icons table, and does that table include " + "an icon called ".concat(name, "?"));
  }

  var svgString = (0, replaceFill_1.default)(icon.data.SVG.localFiles[0].childSvg.svgString, color);
  return {
    text: icon.data.Text,
    svg: svgString
  };
}

exports.default = useCMSIcon;